import * as z from 'zod';
export const DeleteResourceSchema = z.object({
    id: z.uuidv7(),
});
//# sourceMappingURL=util.js.map